import * as React from "react";
import { SvgIcon } from "@mui/material";
import { IconProps } from "./_interface";

const SvgHomeSelectedIcon = (props: IconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 28 28">
      <path fillRule="evenodd" clipRule="evenodd" d="M15.6488 2.61034L24.5651 8.55422C24.9723 8.82573 25.3061 9.19356 25.5369 9.62506C25.7678 10.0566 25.8885 10.5384 25.8884 11.0277V22.9165C25.8885 23.3068 25.8117 23.6934 25.6624 24.054C25.5131 24.4146 25.2942 24.7423 25.0182 25.0184C24.7422 25.2944 24.4146 25.5134 24.054 25.6628C23.6934 25.8122 23.3068 25.8891 22.9165 25.8891H18.6673V15.4585H9.54395V25.8891H5.08326C4.29497 25.889 3.53901 25.5757 2.98166 25.0183C2.42432 24.4608 2.11125 23.7048 2.11133 22.9165V11.0277C2.11138 10.5384 2.23218 10.0566 2.46302 9.62514C2.69386 9.19367 3.0276 8.82582 3.43465 8.55422L12.3516 2.61034C12.8399 2.28495 13.4135 2.11133 14.0002 2.11133C14.5869 2.11133 15.1605 2.28495 15.6488 2.61034ZM9.54395 25.8891V25.8901H18.6673V25.8891H9.91683H9.54395Z" fill="#C72037"/>
    </SvgIcon>
  );
};

export default SvgHomeSelectedIcon;
